import { SearchCriteria } from "./search-criteria";

export class SearchRequest {
    pageNumber: number;
    pageSize: number;
    sortOrder: string[];
    sort: string;
    searchBy: String;
    searchCriteria: SearchCriteria[];
    isAdvancedSearch:boolean;
    valenceSearch?:boolean;
    searchAccountUsingAlternativeLanguage?:boolean;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/search-request.ts